
export function toggleError (type, elem){

    var value = $(elem).val();
    if(value == 'undefined' || value == ''){
        elem.addClass("has-error");
        return true;
    }

    if (type == 'email') {
        if (!jsUtils.validateMail($(elem).val())){
            elem.addClass("has-error");
            return true;
        }
    }
    else if (type == 'checkbox') {
        if(!$(elem).is(':checked')){
            elem.next().addClass("has-error");
            return true;
        }
    }

    return false;
}

export function saveGoogleConversionFor(agencyType) {
    if (typeof (goog_report_conversion) == "function") {
        goog_report_conversion(agencyType);
    }
}